import { SubscriptionStatus, SubscriptionType } from '@thurstech/commons/dist/entity/subscription';
import { PaymentDetail } from '@thurstech/commons/dist/models/booking';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { StatusBadge } from './StatusBadge';
import { useAppDispatch, useAppSelector } from '../../../hooks/store';
import { errorMessage, infoMessage, successMessage } from '../../../hooks/useNotifications';
import { createSubscriptionThunk, getSubscriptionThunk } from '../../../redux/reducer/propSlice';
import { withErrorHandler } from '../../../utils/utils';

export const Subscription: React.FC = () => {
  const dispatch = useAppDispatch();
  const { businessDetail, subscription, isLoading } = useAppSelector(state => state.prop);
  const [searchParams] = useSearchParams();

  const [paymentDetail, setPaymentDetail] = useState<PaymentDetail>();
  const type = searchParams.get('type') ?? '';
  const payNowParam = searchParams.get('payNow') ?? '';

  const status = searchParams.get('status');

  useEffect(() => {
    if (
      !paymentDetail &&
      payNowParam === 'true' &&
      Object.values(SubscriptionType).indexOf(type as SubscriptionType) !== -1
    ) {
      if (businessDetail?.phoneNumber) {
        withErrorHandler(async () => {
          setPaymentDetail(
            await dispatch(createSubscriptionThunk({ type: type as SubscriptionType })).unwrap()
          );
        });
      } else {
        infoMessage('Please fill the business detail form to proceed with payment');
      }
    }
  }, [payNowParam, businessDetail?.phoneNumber]);

  useEffect(() => {
    if (status === SubscriptionStatus.ACTIVE) {
      successMessage('Succesfully subscribed to zittle');
    } else if (status === SubscriptionStatus.FAILED) {
      errorMessage('Failed to subscribe toe zitlle');
    }
  }, [status]);

  useEffect(() => {
    dispatch(getSubscriptionThunk());
  }, []);

  useEffect(() => {
    if (paymentDetail && paymentDetail.data) {
      // Wait for the form to be rendered and submit it
      const form = document.getElementById('payuForm') as HTMLFormElement;
      if (form) {
        form.submit(); // Automatically submit the form
      }
    }
  }, [paymentDetail]);

  const expiry = dayjs(subscription?.expiry);
  return (
    <div className="text-xl font-bold">
      <StatusBadge expiry={expiry} loading={isLoading[getSubscriptionThunk.pending.toString()]} />
      {paymentDetail && (
        <form id="payuForm" method="post" action={paymentDetail.url}>
          {Object.entries(paymentDetail.data).map(([key, value]) => (
            <input type="hidden" key={key} name={key} value={value} />
          ))}
          {/* <script>{(document?.getElementById('payuForm') as HTMLFormElement)?.submit()}</script> */}
        </form>
      )}
    </div>
  );
};
